_collow.components.ImageZoom = class ImageZoom extends _collow.components.Base {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(root, "click", this.enlargeImage);
  }

  enlargeImage = (e) => {
    const target = e.target;
    const src = target.getAttribute("src");

    this.dispatch(this.root, "_collow.enlarge-image", { src });
  };
};
